import { render } from "./MarketingChannelsPage.vue?vue&type=template&id=0971fd25&scoped=true"
import script from "./MarketingChannelsPage.vue?vue&type=script&lang=js"
export * from "./MarketingChannelsPage.vue?vue&type=script&lang=js"

import "./MarketingChannelsPage.vue?vue&type=style&index=0&id=0971fd25&scoped=true&lang=css"

import exportComponent from "F:\\omar pos 2\\pos_administration_platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0971fd25"]])

export default __exports__